import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-corporate-agency',
  templateUrl: './corporate-agency.component.html',
  styleUrls: ['./corporate-agency.component.scss']
})
export class CorporateAgencyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
